module.exports = __webpack_public_path__ + "img/qr_tutor_1000.1f2a5064.png";